;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { ShowOrFranchiseEnum, ShowRowContent } from "./show-data";
import { FranchiseImages } from "./franchise-data";
import { SocialLinkElement } from '@/lib/helpers/get-social-links';
import { LinkWithUrlAndText } from '@/lib/types/api/link-with-url-and-text';

export interface ContentFlags {
    is_new:           boolean;
    is_mvod:          boolean;
    has_captions:     boolean;
    is_expiring_soon: boolean;
    is_fully_watched: null;
}

export enum VideoTypeEnum {
    Episode = "episode",
    Preview = "preview",
    Clip = "clip",
    Special = "special",
    FullLength = "full_length",
    // This really isn't what we get, but we use it as a fallback
    Video = "video",
    // For rare, special events
    Live = "live",
}

export interface SeasonElement {
    cid:     string;
    ordinal: number;
}

export interface VideosStrip {
    has_more_from_collection: boolean;
}

export interface VideoRowCollection {
    title: string;
    title_link?: string;
    content: VideoClass[];
    description?: string;
    slug?: string;
    call_to_action?: boolean;
    has_profile_data?: boolean;
    collection_type?: string;
    url?: string;
    item_type?: string;
    // this doesn't exist as of 5/22/24, but is in the designs
    logo?: string;
    logo_alt?: string;
}

export interface ShowPosterVideoRowCollection {
    call_to_action?: boolean;
    content: VideoClass[];
    default_season?: number;
    description?: string;
    has_scheduled_content?: boolean;
    item_type?: string;
    poster_image?: string;
    seasons?: SeasonElement[];
    show_logo_color?: string;
    show_logo_white?: string;
    show_slug: string;
    slug?: string;
    title_link?: string;
    title: string;
}
export interface GaEvents {
    show_page_tracking_code?:  string;
    show_event_tracking_code?: string;
}

export interface Promo {
    url:         string;
    link:        PromoLink;
    type:        string;
    image:       string;
    title:       string;
    description: string;
}

export interface PromoLink {
    url:   string;
    title: string;
}

export interface ShowRowCollection {
    slug:             string;
    title:            string;
    item_type:        ShowOrFranchiseEnum;
    has_profile_data: boolean;
    collection_type:  string;
    url:              string;
    content:          ShowRowContent[];
    title_link:       string;
}
export interface Audience {
    scope:   string;
    station: null | {
        cid: string;
        call_sign: string;
        short_common_name: string;
    };
}

export interface Genre {
    cid:        string;
    slug:       string;
    title:      string;
    item_type?: string;
    url:        string;
}

export interface ContentImages {
    "show-logo"?:         string;
    "show-mezzanine16x9": string;
    "show-poster2x3":     string;
    "show-showcase"?:     string;
    "show-white-logo"?:   string;
    "show-black-logo"?:   string;
    "show-color-logo"?:   string;
    "white-logo-41"?:     string;
    "black-logo-41"?:     string;
    "color-logo-41"?:     string;
    background?:          string;
    "show-banner"?:       string;
}

export interface LinkElement {
    value:      string;
    profile:    string;
    updated_at: Date;
}

export interface VideoClass {
    slug:                          string;
    title:                         string;
    title_sortable:                string;
    url:                           string;
    duration:                      number;
    description_short:             string;
    video_type:                    VideoTypeEnum;
    premiere_date:                 string;
    encore_date:                   string;
    expire_date:                   string | null;
    available_date?:               string;
    seconds_watched:               null;
    images:                        VideoImages;
    description_long:              string;
    flags:                         VideoFlags;
    hls_videos?:                    ClosedCaption[];
    hls_drm_videos?:                any[];
    dash_drm_videos?:               any[];
    mp4_videos?:                    ClosedCaption[];
    funder_message?:                string;
    closed_captions?:               ClosedCaption[];
    transcripts?:                   CaptionsLanguage[];
    captions_language?:             CaptionsLanguage[];
    chapters?:                      any[];
    related_links?:                 any[];
    related_promos?:                any[];
    links?:                         LinkElement[];
    hero_links?:                    LinkWithUrlAndText[];
    availability:                  string;
    content_rating?:                string;
    content_rating_descriptor?:     any[];
    is_excluded_from_dfp?:          boolean;
    item_type:                     string;
    trick_play_files?:              any[];
    enhance_html_title_tag?:        string;
    audio:                         Audio[];
    parent_type:                   "episode" | "preview" | "clip" | "special" | "full_length" | "season" | "franchise" | "show" | "video";
    show?:                         VideoShow;
    franchise?:                    VideoFranchise;
    summary:                       string;
    ancestor_title:                string;
    ancestor_slug:                 string;
    ancestor_type:                 "show" | "franchise" | "season";
    ancestor_white_logo?:          string;
    image:                         string;
    legacy_tp_media_id:            number;
    cid:                           string;
    share?:                         Share;
    has_audio_description?:         boolean;
    meta_title?:                    string;
    related_accessibility_videos?:  RelatedAccessibilityVideo[];
    related_video_asset?:           RelatedVideoAsset | null;
    related_is_expired?:            boolean;
    related_content_title?:         string;
    test_data?:                     boolean;
    transcript?:                    string[];
    transcript_file?:               string;
    sponsor_logos?:                 any[];
    local_content_stations?:        any[];
    local_content_station_ids?:     string[];
    genre?:                         Genre;
    // this is really removed in the normalization process, but is here to keep TS happy
    parent?:                        Parent;
    learning_media_url?:            string;
    ga_events?:                     GaEvents;
}

export interface RelatedAccessibilityVideo {
    accessibility_profile: 'asl' | 'ead-english' | 'ead-spanish' | 'oc-english' | 'oc-spanish' | 'non-enhanced';
}

export interface Audio {
    channel:     string;
    language:    string;
    descriptive: boolean;
}

export interface CaptionsLanguage {
    url:      string;
    primary:  boolean;
    profile:  string;
    language: string;
}

export interface ClosedCaption {
    url:     string;
    profile: string;
}

export interface VideoFlags {
    is_new:                   boolean;
    is_mvod:                  boolean;
    has_captions:             boolean;
    is_expiring_soon?:        boolean;
    is_fully_watched?:        boolean | null;
    is_playable:              boolean;
    is_playable_explanation:  string[] | null;
    can_embed_player?:        boolean;
    is_in_watchlist?:         null;
    is_uhd?:                  boolean;
}

export interface VideoImages {
    [key: string]: string | undefined;
    "asset-mezzanine-16x9": string;
    "asset-original"?: string;
}

export interface RelatedVideoAsset {
    cid:                string;
    slug:               string;
    title:              string;
    title_sortable:     string;
    url:                string;
    duration:           number;
    description_short:  string;
    description_long:   string;
    video_type:         VideoTypeEnum;
    premiere_date:      string;
    encore_date:        string;
    expire_date:        string | null;
    availability:       string;
    seconds_watched:    null;
    images:             VideoImages | null;
    flags:              ContentFlags | VideoFlags;
    parent:             Parent;
    legacy_tp_media_id: number;
    item_type:          string;
    audio:              Audio[];
}

// Parent when the video belongs to an episode, preview, clip, etc.
// The show is accessed via parent.season.show, not directly on the parent.
// season uses `| any` intentionally: CS season objects are structurally messy
export interface EpisodeParent {
    resource_type:  "episode" | "preview" | "clip" | "special" | "full_length";
    ordinal:        number;
    slug:           string;
    title:          string;
    cid:            string;
    season?:        ParentSeason | any;
}

// Parent when the video is a season-level asset (e.g. a clip/preview for a whole season)
export interface SeasonParent {
    resource_type: "season";
    ordinal:       number;
    title:         string;
    cid:           string;
    show:          SeasonShow;
}

// Parent when the video is an extra that belongs directly to a show (no episode/season in between)
export interface ShowParent {
    resource_type:          "show";
    slug:                   string;
    title:                  string;
    cid:                    string;
    audience?:              Audience[];
    display_episode_number?: boolean;
    franchise?:             null | Record<string, unknown>; // CS can return a full franchise, {} or null; shape varies widely
    seasons_count?:         number;
    hashtag?:               string;
    genre?:                 Genre;
    images?:                VideoShowImages;
    links?:                 LinkElement[];
    funder_message?:        string;
    tracking_ga_event?:     string;
    tracking_ga_page?:      string;
}

// Parent when the video belongs directly to a franchise (no show in between)
export interface FranchiseParent {
    resource_type:      "franchise";
    slug:               string;
    title:              string;
    cid:                string;
    images?:            FranchiseImages;
    tracking_ga_event?: string;
    tracking_ga_page?:  string;
}

export type Parent = EpisodeParent | ShowParent | FranchiseParent | SeasonParent;

export interface ParentSeason {
    ordinal:       number;
    title:         string;
    show:          SeasonShow;
    cid:           string;
    resource_type: string;
}

export interface VideoHeroParent {
    show: VideoHeroShow;
}

export interface VideoHeroShow {
    slug:  string;
    title: string;
    logos: VideoShowImages;
}
export interface SeasonShow {
    audience:               Audience[];
    display_episode_number: boolean;
    franchise?:             null | Record<string, unknown>; // CS can return a full franchise, {} or null; shape varies widely
    seasons_count:          number;
    slug:                   string;
    title:                  string;
    tracking_ga_event:      string;
    tracking_ga_page:       string;
    cid:                    string;
    resource_type:          ShowOrFranchiseEnum;
    funder_message:         string;
    genre?:                 Genre;
    images?:                VideoShowImages;
    logos?:                 VideoShowImages;
    hashtag?:               string;
    links?:                 LinkElement[];
}

export interface Share {
    title:    string;
    facebook: boolean;
    twitter:  boolean;
    google:   boolean;
    email:    boolean;
    embed:    boolean;
}

export interface VideoShow {
    slug:                    string;
    title:                   string;
    season?:                 number;
    episode?:                number | string;
    seasons_count?:          number;
    display_episode_number?: boolean;
    hashtag?:                string;
    images?:                VideoShowImages;
    logos?:                 VideoShowImages;
    social_links?:          SocialLinkElement[];
}

export interface VideoShowImages {
  "show-mezzanine16x9"?: string,
  "show-poster2x3"?:     string,
  "white-logo-41"?:      string,
  "black-logo-41"?:      string,
  "color-logo-41"?:      string,
  "background"?:         string,
  "show-logo"?:          string,
  "show-white-logo"?:    string,
  "show-black-logo"?:    string,
  "show-color-logo"?:    string,
  "show-banner"?:        string,
  "show-showcase"?:      string,
}


export interface VideoFranchise {
    slug:                   string;
    title:                  string;
    logo:                   string,
    logo_cropped:           string,
    logo_cropped_white:     string,
    image:                  string,
    images?:                FranchiseImages,
    tracking_ga_page?:      string,
}

// CS, on video responses, adds a "station-data" collection with lots of station info.
// For the moment, we only need the passport_learn_more_url from it
export interface VideoCSStationData {
    passport_learn_more_url?: string;
}
